import { Action, CoreActions } from "@Actions/action";
import { ActionMap } from "@Context/common/general/context";
import { isFunction, isString } from "lodash-es";

const stringToAction = (actionName: string) => {
    const actionMatch = ActionMap.find((actionType: Action | CoreActions) => {
      const nameMatch: string | undefined = isFunction(actionType) ? actionType.name : isString(actionType) ? actionType : undefined;
      return nameMatch && nameMatch.toLowerCase() === actionName.toLowerCase();
    });
    if(!actionMatch) {
      console.warn(`Warning: No action found for name "${actionName}" fallback to NoOp`);
      return CoreActions.NoOp;
    }
    return actionMatch;
  }

export default stringToAction;